export default "__VITE_ASSET__CZ6dc6eH__"